var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var errorReducer = function (items, action) {
    var _a;
    switch (action.type) {
        case 'SET_FATAL_ERROR': {
            return __assign(__assign({}, items), { fatal: action.item });
        }
        case 'CLEAR_FATAL_ERROR': {
            return __assign(__assign({}, items), { fatal: null });
        }
        case 'SET_LOCAL_ERROR': {
            var key = action.key || 'global';
            return __assign(__assign({}, items), { local: __assign(__assign({}, items.local), (_a = {}, _a[key] = action.item, _a)) });
        }
        case 'CLEAR_LOCAL_ERROR': {
            if (!action.key) {
                return __assign(__assign({}, items), { local: {} });
            }
            var nextLocal = __assign({}, items.local);
            delete nextLocal[action.key];
            return __assign(__assign({}, items), { local: nextLocal });
        }
        default: {
            var exhaustiveCheck = action;
            throw Error("ErrorReducer: Unhandled action ".concat(String(exhaustiveCheck)));
        }
    }
};
export default errorReducer;
